import React, { useEffect ,useState} from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createTvPrograms, getTvProgram, resetState, updateTvProgram } from "../features/RadioProgram/RadioProgramSlice";
import { toast } from "react-toastify";
import CustomInput from "../components/CustomInput";
let schema = yup.object().shape({
  name: yup.string().required("Name is Required"),
  time: yup.string().required("time is Required"),
});

const AddTvProgram = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const getNewsId = location.pathname.split("/")[3];
  const NewsState = useSelector((state) => state.radioprogram);
  const { isSuccess, isError, isLoading, createdTvProgram, TvProgramName, TvProgramtime, updatedTvProgram } = NewsState;
  const [image, setImage] = useState(null);
  const [imageError, setImageError] = useState("");
  

  useEffect(() => {
    if (getNewsId !== undefined) {
      dispatch(getTvProgram(getNewsId));
    } else {
      dispatch(resetState());
    }
  }, [getNewsId]);

  useEffect(() => {
    dispatch(resetState());
   
  }, []);

  useEffect(() => {
    if (isSuccess && createdTvProgram) {
      toast.success("TvProgram Added Successfully!");
      dispatch(resetState());
      navigate("/admin/Radio-Program-list");
    }
    if (isSuccess && updatedTvProgram) {
      toast.success("TvProgram Updated Successfully!");
      navigate("/admin/Radio-Program-list");
    }
    if (isError) {
      toast.error("Something Went Wrong!");
    }
  }, [isSuccess, isError, isLoading]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      
      name: TvProgramName || "",
      time: TvProgramtime || "",
      
    },
    validationSchema: schema,
    onSubmit: (values) => {
      if (!image ) {
        setImageError("Please select an image.");
        return;
      } else {
        setImageError("");
      }
      
      const formData = new FormData();
      
      formData.append("name", values.name);
      formData.append("time", values.time);
      formData.append("image", image);
      
      if (getNewsId !== undefined) {
        const data = { id: getNewsId, NewsData: formData };
        dispatch(updateTvProgram(data));
        dispatch(resetState());
      } else {
        dispatch(createTvPrograms(formData));
        setImage(null);
        formik.resetForm();
        setTimeout(() => {
          dispatch(resetState());
        }, 300);
      }
    },
  });



  return (
    <div>
      <h3 className="mb-4 title">{getNewsId !== undefined ? "Edit" : "Add"} Radio Program</h3>

      <div className="">
        <form action="" onSubmit={formik.handleSubmit}>
          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter TvProgram Name"
              name="name"
              onChng={formik.handleChange("name")}
              onBlr={formik.handleBlur("name")}
              val={formik.values.name}
            />
            <div className="error">{formik.touched.name && formik.errors.name}</div>
          </div>

          <div className="mt-4">
            <CustomInput
              type="text"
              label="Enter TvProgram time"
              name="time"
              onChng={formik.handleChange("time")}
              onBlr={formik.handleBlur("time")}
              val={formik.values.time}
            />
            <div className="error">{formik.touched.time && formik.errors.time}</div>
          </div>

          
          <div className="mt-4">
            <label htmlFor="image" className="form-label">
              Select Logo
            </label>
            <input
              type="file"
              id="image"
              name="image"
              accept="image/*"
              onChange={(e) => {
                setImage(e.target.files[0]);
                setImageError(""); 
              }}
              className="form-control"
            />
            <div className="error">{imageError}</div>
          </div>

          

          <button className="btn btn-success border-0 rounded-3 my-5" type="submit">
            {getNewsId !== undefined ? "Edit" : "Add"} Radio Program
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddTvProgram;